import createTableStore from "ds/components/Table/store/useTableStore";

import {
  TEMPLATE_VERSIONS_COLUMN_CONFIG,
  TEMPLATE_VERSIONS_COLUMNS_STORAGE_KEY,
} from "./constants";

const useTemplateVersionsTableStore = createTableStore({
  storageKey: TEMPLATE_VERSIONS_COLUMNS_STORAGE_KEY,
  config: TEMPLATE_VERSIONS_COLUMN_CONFIG,
});
export default useTemplateVersionsTableStore;
